import { handleResponse, transfromObjectToQueryString } from "./utilsApi"
import * as url from './routes'

/**
 * to get street gauge zone static + dynamic data
 * @param {object} position - {lat: float, lng: float}
 * @param {array} loadedSgz - array containing all the id of the sgz already loaded
 */
export function getSgzStaticAndDynamicData(position, loadedSgz){
    return new Promise((resolve, reject)=>{        
        let dataToSend = transfromObjectToQueryString({
            lat: position.lat,
            lng: position.lng,
            loaded_sgz: loadedSgz
        });
        fetch(url.streetGaugeZoneData + dataToSend)
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
        .catch(err=> resolve("error"))
    })
}
